import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';

import { injectCatchHttpError } from '../../../core/errors/catch-http-error.util';
import { DateTimeService } from '../../../core/services/date-time/date-time.service';
import type { ILocalizationSettings } from '../../models/responses';
import { ApiUserService } from '../../services/api-user.service';
import { loadLocalizationSettings, loadLocalizationSettingsFail, loadLocalizationSettingsSuccess } from './user-settings.actions';

@Injectable()
export class UserSettingsEffects {
  private apiUser = inject(ApiUserService);
  private dateTimeService = inject(DateTimeService);

  private readonly actions$ = inject<Actions>(Actions);
  private readonly catchHttpError = injectCatchHttpError();

  getUserSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadLocalizationSettings),
      switchMap(() =>
        this.apiUser.getLocalisationSettings().pipe(
          map((settings: ILocalizationSettings) => {
            this.dateTimeService.setFormats(settings);
            return loadLocalizationSettingsSuccess({ settings });
          }),
          this.catchHttpError(() => loadLocalizationSettingsFail()),
        ),
      ),
    ),
  );
}
